module.exports = "/_next/static/images/harajuku_washoku-b2d2f8c7b81fa9eb44889acc5fb415be.jpg";